// extracted by mini-css-extract-plugin
export var root = "Card-module--root--31f6b";
export var section = "Card-module--section--5756e";